(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('[data-accordion]');

    accordions.forEach((accordion) => {
      const singleOpen = accordion.dataset.singleOpen === 'true';
      const openFirst = accordion.dataset.openFirst === 'true';
      const collapsibleItems = accordion.querySelectorAll('collapsible-content');

      // Open first item if setting is enabled
      if (openFirst && collapsibleItems.length > 0) {
        const firstItem = collapsibleItems[0];
        firstItem.openContent();
      }

      // Handle single open mode
      if (singleOpen) {
        collapsibleItems.forEach((item) => {
          item.toggleButton.addEventListener('click', function () {
            // Close all other items
            collapsibleItems.forEach((otherItem) => {
              if (otherItem !== item) {
                otherItem.closeContent();
              }
            });
          });
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["boarding-rooms-comparison"] && !Shopify.designMode) return;
  try {
    class RoomComparisonTabs extends HTMLElement {
    constructor() {
      super();
      this.tabButtons = this.querySelectorAll('.room-tab');
      this.tabContents = this.querySelectorAll('.room-content');
    }

    connectedCallback() {
      this.tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const roomType = button.dataset.room;

          // Update tab buttons
          this.tabButtons.forEach((tab) => {
            if (tab.dataset.room === roomType) {
              tab.setAttribute('aria-selected', 'true');
            } else {
              tab.setAttribute('aria-selected', 'false');
            }
          });

          // Update tab content
          this.tabContents.forEach((content) => {
            if (content.dataset.roomContent === roomType) {
              content.classList.remove('hidden');
            } else {
              content.classList.add('hidden');
            }
          });
        });
      });
    }
  }

  customElements.define('room-comparison-tabs', RoomComparisonTabs);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["boarding-rooms"] && !Shopify.designMode) return;
  try {
    class BoardingRoomsToggle extends HTMLElement {
    constructor() {
      super();
      // this.toggleButtons = this.querySelectorAll('.room-toggle');
      this.tabButtons = this.querySelectorAll('.tab-btn');
      this.roomCards = this.querySelectorAll('.room-card');
    }

    connectedCallback() {
      // Initialize with dogs showing by default
      this.roomCards.forEach((card) => {
        const petType = card.dataset.petType;
        if (petType !== 'dogs') {
          card.classList.add('hidden');
        }
      });

      this.tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const targetTab = button.dataset.tab;

          // Update active tab
          this.tabButtons.forEach((btn) => btn.classList.remove('active'));
          button.classList.add('active');

          // Show/hide rooms
          this.roomCards.forEach((card) => {
            const petType = card.dataset.petType;

            if (petType === targetTab) {
              card.classList.remove('hidden');
            } else {
              card.classList.add('hidden');
            }
          });
        });
      });
    }
  }

  customElements.define('boarding-rooms-toggle', BoardingRoomsToggle);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collapsible-content"] && !Shopify.designMode) return;
  try {
    class CollapsibleContent extends HTMLElement {
    constructor() {
      super();
      this.toggleButton = this.querySelector('button');
      this.content = document.getElementById(this.toggleButton.getAttribute('aria-controls'));
    }

    connectedCallback() {
      this.toggleButton.addEventListener('click', (event) => {
        const isExpanded = this.toggleButton.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          this.closeContent();
        } else {
          this.openContent();
        }
      });
    }

    openContent() {
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.content.setAttribute('aria-hidden', 'false');
    }

    closeContent() {
      this.toggleButton.setAttribute('aria-expanded', 'false');
      this.content.setAttribute('aria-hidden', 'true');
    }
  }

  customElements.define('collapsible-content', CollapsibleContent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["daycare-pricing"] && !Shopify.designMode) return;
  try {
    class DaycarePricingToggle extends HTMLElement {
    constructor() {
      super();
      this.tabButtons = this.querySelectorAll('.tab-btn');
      this.pricingContent = this.querySelectorAll('.pricing-content');
    }

    connectedCallback() {
      // Initialize with half-day showing by default
      this.pricingContent.forEach((content) => {
        const duration = content.dataset.duration;
        if (duration !== 'half-day') {
          content.classList.add('hidden');
        }
      });

      this.tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const targetTab = button.dataset.tab;

          // Update active tab
          this.tabButtons.forEach((btn) => btn.classList.remove('active'));
          button.classList.add('active');

          // Show/hide pricing content
          this.pricingContent.forEach((content) => {
            const duration = content.dataset.duration;

            if (duration === targetTab) {
              content.classList.remove('hidden');
            } else {
              content.classList.add('hidden');
            }
          });
        });
      });
    }
  }

  customElements.define('daycare-pricing-toggle', DaycarePricingToggle);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["grooming-pricing"] && !Shopify.designMode) return;
  try {
    class GroomingPricingToggle extends HTMLElement {
    constructor() {
      super();
      this.tabButtons = this.querySelectorAll('.tab-btn');
      this.pricingContent = this.querySelectorAll('.pricing-content');
    }

    connectedCallback() {
      // Initialize with basic showing by default
      this.pricingContent.forEach((content) => {
        const tier = content.dataset.tier;
        if (tier !== 'basic') {
          content.classList.add('hidden');
        }
      });

      this.tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const targetTab = button.dataset.tab;

          // Update active tab
          this.tabButtons.forEach((btn) => btn.classList.remove('active'));
          button.classList.add('active');

          // Show/hide pricing content
          this.pricingContent.forEach((content) => {
            const tier = content.dataset.tier;

            if (tier === targetTab) {
              content.classList.remove('hidden');
            } else {
              content.classList.add('hidden');
            }
          });
        });
      });
    }
  }

  customElements.define('grooming-pricing-toggle', GroomingPricingToggle);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["location-switcher"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.querySelector('.location-switcher > button');
    const overlay = document.getElementById('location-panel-overlay');
    const panel = document.getElementById('location-panel');
    const closeBtn = document.querySelector('.location-panel-close');
    const locationItems = document.querySelectorAll('.location-item');

    function openPanel() {
      document.documentElement.classList.add('overflow-y-hidden');
      panel.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');

      // Focus management
      closeBtn.focus();
    }

    function closePanel() {
      document.documentElement.classList.remove('overflow-y-hidden');
      panel.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');

      // Return focus to trigger
      trigger.focus();
    }

    // Event listeners
    if (trigger) {
      trigger.addEventListener('click', openPanel);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closePanel);
    }

    if (overlay) {
      overlay.addEventListener('click', closePanel);
    }

    // Close on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.documentElement.classList.contains('overflow-y-hidden')) {
        closePanel();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
